/* Guías del asistente. Ver el contrato de campos en ../guides.js
 * Extra de este bloque: `examples` = [{ group, items[] }], frases listas para
 * copiar y pegar en el chat. Es lo que más pide la gente que empieza. */

export const GUIDES_AI = [
  {
    slug: 'what-to-ask-the-assistant',
    id: 'ask-the-assistant',
    category: 'ai',
    icon: 'message-circle-question',
    level: 'basic',
    plan: 'free',
    minutes: 6,
    topics: [
      'què li puc demanar', 'qué le puedo pedir', 'ejemplos', 'exemples', 'what can i ask',
      'no sé qué preguntar', 'ideas', 'idees', 'prompts', 'asistente', 'assistant', 'chat ia',
      'para qué sirve la ia', 'per a què serveix', 'cómo hablo con la ia',
    ],
    ca: {
      title: 'Què li pots demanar a l’assistent (amb exemples per copiar)',
      lead: 'No cal aprendre paraules màgiques. Parla-hi com parlaries a algú que t’ajuda amb el correu.',
      answer:
        'A l’assistent li pots demanar que resumeixi, que redacti, que tradueixi, que busqui correus, que et digui què tens pendent i que et prepari accions. Escriu-li amb paraules normals al panell de la dreta; si vols que parli d’un correu concret, obre’l abans.',
      steps: [
        {
          t: 'Obre el panell de la dreta',
          d: 'És el panell de l’assistent. Si no el veus, activa’l amb el botó de l’assistent a dalt de la finestra.',
          screen: 'chat',
          highlight: 'thread',
        },
        {
          t: 'Obre abans el correu del qual vols parlar',
          d: 'L’assistent sap de què li parles perquè veu el correu que tens obert. Si no n’hi ha cap, contestarà en general.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Escriu-li amb paraules normals',
          d: '“Resumeix-me això”, “contesta que hi aniré dijous”, “què vol dir aquest correu?”. No cal ser educat ni fer frases perfectes.',
          screen: 'chat',
          highlight: 'input',
        },
        {
          t: 'Si no t’agrada, digues-l’hi',
          d: 'Contesta-li al mateix xat: “massa llarg”, “més sec”, “tracta’l de vostè”. Recorda tota la conversa i ho refà. Mentre treballa veus cada consulta que fa.',
          screen: 'chat-proposal',
          highlight: 'tools',
        },
      ],
      examples: [
        {
          group: 'Entendre què t’han escrit',
          items: [
            'Resumeix-me aquesta conversa en cinc línies.',
            'Què m’està demanant exactament aquesta persona?',
            'Hi ha cap data o cap termini en aquest correu?',
            'Explica-m’ho com si no hi entengués gens.',
            'Aquest correu sembla una estafa?',
          ],
        },
        {
          group: 'Contestar',
          items: [
            'Contesta que sí, que hi seré dijous a les deu.',
            'Digues-li amablement que aquesta setmana no puc.',
            'Prepara’m una resposta demanant el pressupost per escrit.',
            'Contesta-li en anglès, que és el seu idioma.',
            'Fes-me una resposta més curta i menys formal.',
            'Redacta la resposta però no l’enviïs, la vull llegir abans.',
          ],
        },
        {
          group: 'Escriure de zero',
          items: [
            'Escriu un correu a l’administrador de la finca demanant quan arreglaran l’ascensor.',
            'Escriu-li a la Marta felicitant-la per la jubilació.',
            'Fes un correu per anul·lar la cita del dentista de dimarts.',
            'Escriu una reclamació per un paquet que no ha arribat.',
          ],
        },
        {
          group: 'Buscar entre els teus correus',
          items: [
            'Busca’m el correu on em passaven el pressupost de la caldera.',
            'Qui em va enviar les fotos del casament?',
            'Ensenya’m els correus del banc d’aquest mes.',
            'Busca dins dels PDF si algú m’ha passat una factura de l’assegurança.',
          ],
        },
        {
          group: 'Posar ordre',
          items: [
            'Què tinc pendent de contestar?',
            'Resumeix-me els correus d’avui.',
            'Quins correus d’aquesta setmana són importants de debò?',
            'Passa aquest correu a la carpeta de la comunitat.',
          ],
        },
        {
          group: 'Coses del dia a dia',
          items: [
            'Envia aquesta resposta demà al matí, no ara.',
            'Adjunta-li el PDF que em van enviar l’altre dia.',
            'Desa aquesta resposta com a plantilla, que la repeteixo cada mes.',
            'Recorda’m aquest correu la setmana que ve.',
          ],
        },
      ],
      tips: [
        'Pots parlar-li en català, castellà o anglès: et contesta en l’idioma en què li escrius.',
        'Si li demanes que faci alguna cosa que canvia coses de debò (enviar, esborrar, pagar), et deixa el botó preparat i no ho fa fins que tu el premes.',
      ],
      faq: [
        {
          q: 'M’equivocaré si li demano alguna cosa rara?',
          a: 'No. Si no ho entén, t’ho pregunta. I res del que redacti s’envia sol: sempre hi ha un pas on ho llegeixes tu.',
        },
        {
          q: 'Cal escriure-ho tot ben escrit?',
          a: 'No. Entén frases a mitges, faltes i abreviatures. Escriu-li com parlaries.',
        },
      ],
    },
    es: {
      title: 'Qué le puedes pedir al asistente (con ejemplos para copiar)',
      lead: 'No hay que aprenderse palabras mágicas. Háblale como le hablarías a alguien que te echa una mano con el correo.',
      answer:
        'Al asistente le puedes pedir que resuma, que redacte, que traduzca, que busque correos, que te diga qué tienes pendiente y que te prepare acciones. Escríbele con palabras normales en el panel de la derecha; si quieres que hable de un correo concreto, ábrelo antes.',
      steps: [
        {
          t: 'Abre el panel de la derecha',
          d: 'Es el panel del asistente. Si no lo ves, actívalo con el botón del asistente en la parte de arriba de la ventana.',
          screen: 'chat',
          highlight: 'thread',
        },
        {
          t: 'Abre antes el correo del que quieras hablar',
          d: 'El asistente sabe de qué le hablas porque ve el correo que tienes abierto. Si no hay ninguno, contestará en general.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Escríbele con palabras normales',
          d: '“Resúmeme esto”, “contesta que iré el jueves”, “¿qué quiere decir este correo?”. No hace falta ser educado ni hacer frases perfectas.',
          screen: 'chat',
          highlight: 'input',
        },
        {
          t: 'Si no te gusta, díselo',
          d: 'Contéstale en el mismo chat: “demasiado largo”, “más seco”, “trátalo de usted”. Recuerda toda la conversación y lo rehace. Mientras trabaja ves cada consulta que hace.',
          screen: 'chat-proposal',
          highlight: 'tools',
        },
      ],
      examples: [
        {
          group: 'Entender lo que te han escrito',
          items: [
            'Resúmeme esta conversación en cinco líneas.',
            '¿Qué me está pidiendo exactamente esta persona?',
            '¿Hay alguna fecha o algún plazo en este correo?',
            'Explícamelo como si no entendiera nada del tema.',
            '¿Este correo parece una estafa?',
          ],
        },
        {
          group: 'Contestar',
          items: [
            'Contesta que sí, que estaré el jueves a las diez.',
            'Dile amablemente que esta semana no puedo.',
            'Prepárame una respuesta pidiendo el presupuesto por escrito.',
            'Contéstale en inglés, que es su idioma.',
            'Hazme una respuesta más corta y menos formal.',
            'Redacta la respuesta pero no la envíes, quiero leerla antes.',
          ],
        },
        {
          group: 'Escribir desde cero',
          items: [
            'Escribe un correo al administrador de la finca preguntando cuándo arreglan el ascensor.',
            'Escríbele a Marta felicitándola por su jubilación.',
            'Haz un correo para anular la cita del dentista del martes.',
            'Escribe una reclamación por un paquete que no ha llegado.',
          ],
        },
        {
          group: 'Buscar entre tus correos',
          items: [
            'Búscame el correo donde me pasaban el presupuesto de la caldera.',
            '¿Quién me mandó las fotos de la boda?',
            'Enséñame los correos del banco de este mes.',
            'Busca dentro de los PDF si alguien me ha pasado una factura del seguro.',
          ],
        },
        {
          group: 'Poner orden',
          items: [
            '¿Qué tengo pendiente de contestar?',
            'Resúmeme los correos de hoy.',
            '¿Qué correos de esta semana son importantes de verdad?',
            'Pasa este correo a la carpeta de la comunidad.',
          ],
        },
        {
          group: 'Cosas del día a día',
          items: [
            'Envía esta respuesta mañana por la mañana, no ahora.',
            'Adjúntale el PDF que me mandaron el otro día.',
            'Guarda esta respuesta como plantilla, que la repito cada mes.',
            'Recuérdame este correo la semana que viene.',
          ],
        },
      ],
      tips: [
        'Puedes hablarle en castellano, catalán o inglés: te contesta en el idioma en que le escribes.',
        'Si le pides algo que cambia cosas de verdad (enviar, borrar, pagar), te deja el botón preparado y no lo hace hasta que lo pulsas tú.',
      ],
      faq: [
        {
          q: '¿Me voy a equivocar si le pido algo raro?',
          a: 'No. Si no lo entiende, te lo pregunta. Y nada de lo que redacte se envía solo: siempre hay un paso donde lo lees tú.',
        },
        {
          q: '¿Hay que escribirlo todo bien escrito?',
          a: 'No. Entiende frases a medias, faltas y abreviaturas. Escríbele como hablarías.',
        },
      ],
    },
    en: {
      title: 'What you can ask the assistant (with examples to copy)',
      lead: 'There are no magic words to learn. Talk to it the way you would talk to someone helping you with your mail.',
      answer:
        'You can ask the assistant to summarise, draft, translate, search your emails, tell you what is still pending and prepare actions for you. Write in plain words in the right-hand panel; if you want it to talk about a specific email, open that email first.',
      steps: [
        {
          t: 'Open the panel on the right',
          d: 'That is the assistant panel. If you cannot see it, switch it on with the assistant button at the top of the window.',
          screen: 'chat',
          highlight: 'thread',
        },
        {
          t: 'Open the email you want to talk about',
          d: 'The assistant knows what you mean because it can see the email you have open. With no email open it answers in general terms.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Write in plain words',
          d: '“Summarise this”, “say I will be there on Thursday”, “what does this email mean?”. No need to be polite or write perfect sentences.',
          screen: 'chat',
          highlight: 'input',
        },
        {
          t: 'If you do not like it, say so',
          d: 'Answer in the same chat: “too long”, “more direct”, “be more formal”. It remembers the whole conversation and redoes it. While it works you see every lookup it makes.',
          screen: 'chat-proposal',
          highlight: 'tools',
        },
      ],
      examples: [
        {
          group: 'Understanding what you were sent',
          items: [
            'Summarise this conversation in five lines.',
            'What exactly is this person asking me for?',
            'Is there a date or a deadline in this email?',
            'Explain it as if I knew nothing about the subject.',
            'Does this email look like a scam?',
          ],
        },
        {
          group: 'Replying',
          items: [
            'Say yes, I will be there on Thursday at ten.',
            'Politely tell them I cannot make it this week.',
            'Draft a reply asking for the quote in writing.',
            'Answer in Spanish, that is their language.',
            'Make the reply shorter and less formal.',
            'Draft the reply but do not send it, I want to read it first.',
          ],
        },
        {
          group: 'Writing from scratch',
          items: [
            'Write to the building manager asking when the lift will be fixed.',
            'Write to Marta congratulating her on her retirement.',
            'Write an email cancelling Tuesday’s dentist appointment.',
            'Write a complaint about a parcel that never arrived.',
          ],
        },
        {
          group: 'Searching your mail',
          items: [
            'Find the email with the quote for the boiler.',
            'Who sent me the wedding photos?',
            'Show me this month’s emails from the bank.',
            'Look inside the PDFs and see if anyone sent me an insurance invoice.',
          ],
        },
        {
          group: 'Getting organised',
          items: [
            'What am I still supposed to reply to?',
            'Summarise today’s emails.',
            'Which emails from this week actually matter?',
            'Move this email to the building folder.',
          ],
        },
        {
          group: 'Everyday jobs',
          items: [
            'Send this reply tomorrow morning, not now.',
            'Attach the PDF they sent me the other day.',
            'Save this reply as a template, I send it every month.',
            'Remind me about this email next week.',
          ],
        },
      ],
      tips: [
        'You can write to it in English, Spanish or Catalan: it answers in the language you use.',
        'If you ask for something that really changes things (send, delete, pay), it leaves the button ready and does nothing until you press it.',
      ],
      faq: [
        {
          q: 'Will I break something if I ask for something odd?',
          a: 'No. If it does not understand, it asks. And nothing it drafts is sent on its own — there is always a step where you read it.',
        },
        {
          q: 'Do I have to write properly?',
          a: 'No. It copes with half sentences, typos and abbreviations. Write the way you speak.',
        },
      ],
    },
  },

  {
    slug: 'reply-with-ai',
    id: 'reply-with-ai',
    category: 'ai',
    icon: 'zap',
    level: 'basic',
    plan: 'free',
    minutes: 4,
    topics: [
      'respondre ràpid', 'responder rápido', 'reply faster', 'responder con ia', 'respondre amb ia',
      'reply with ai', 'borrador', 'esborrany', 'draft', 'contestar rápido', 'me cuesta escribir',
      'no sé qué poner', 'redactar respuesta',
    ],
    ca: {
      title: 'Respondre un correu en tres clics amb la IA',
      lead: 'La manera més ràpida de contestar: obrir, prémer un botó i llegir el que t’ha escrit.',
      answer:
        'Obre el correu i prem “Respon amb IA” a la barra de sota. Nukli llegeix tota la conversa i deixa un esborrany a la caixa de resposta amb el teu to. Llegeix-lo, canvia el que vulguis i envia’l tu.',
      steps: [
        {
          t: 'Obre el correu',
          d: 'Un clic a la fila de la llista, com sempre. Cal tenir el correu obert perquè la IA sàpiga de què va.',
          screen: 'inbox',
          highlight: 'list',
        },
        {
          t: 'Prem “Respon amb IA”',
          d: 'És el botó amb l’estrelleta, a la barra de sota del missatge. Al costat del botó de respondre normal.',
          screen: 'reader',
          highlight: 'actions',
        },
        {
          t: 'Espera dos segons',
          d: 'Nukli llegeix el fil sencer i mira com has contestat tu abans en correus semblants, per escriure amb la teva manera de dir les coses.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Llegeix-ho i toca el que vulguis',
          d: 'L’esborrany apareix a la caixa de resposta. És text normal: pots esborrar, afegir i canviar el que et sembli.',
          screen: 'reader',
          highlight: 'actions',
          tip: 'Si no t’agrada gens, no el toquis: demana-li un altre al panell de l’assistent.',
        },
        {
          t: 'Envia’l tu',
          d: 'Res s’envia sol. Quan estiguis conforme, prem enviar.',
          screen: 'reader',
          highlight: 'actions',
        },
      ],
      tips: [
        'Si vols dir-li com ha de ser la resposta abans que l’escrigui, fes servir les respostes suggerides: hi ha una guia dedicada.',
        'Com més el facis servir, més s’assembla a tu: aprèn dels correus que has enviat.',
      ],
      faq: [
        {
          q: 'S’enviarà sol sense que ho vegi?',
          a: 'Mai. Nukli deixa el text escrit i prou; el botó d’enviar el prems tu.',
        },
        {
          q: 'I si diu alguna cosa que no és certa?',
          a: 'Per això el llegeixes abans. Si dubtes d’un detall, esborra’l: la IA és bona escrivint, no endevinant.',
        },
        {
          q: 'Consumeix del meu pla?',
          a: 'Sí, cada resposta gasta una miqueta de la teva quota d’IA del mes. Ho pots mirar a Configuració > Compte.',
        },
      ],
    },
    es: {
      title: 'Responder un correo en tres clics con la IA',
      lead: 'La forma más rápida de contestar: abrir, pulsar un botón y leer lo que te ha escrito.',
      answer:
        'Abre el correo y pulsa “Responder con IA” en la barra de abajo. Nukli lee toda la conversación y deja un borrador en la caja de respuesta con tu tono. Léelo, cambia lo que quieras y envíalo tú.',
      steps: [
        {
          t: 'Abre el correo',
          d: 'Un clic en la fila de la lista, como siempre. Hay que tener el correo abierto para que la IA sepa de qué va.',
          screen: 'inbox',
          highlight: 'list',
        },
        {
          t: 'Pulsa “Responder con IA”',
          d: 'Es el botón con la estrellita, en la barra de debajo del mensaje. Al lado del botón de responder normal.',
          screen: 'reader',
          highlight: 'actions',
        },
        {
          t: 'Espera dos segundos',
          d: 'Nukli lee el hilo entero y mira cómo has contestado tú antes en correos parecidos, para escribir con tu manera de decir las cosas.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Léelo y toca lo que quieras',
          d: 'El borrador aparece en la caja de respuesta. Es texto normal: puedes borrar, añadir y cambiar lo que te parezca.',
          screen: 'reader',
          highlight: 'actions',
          tip: 'Si no te gusta nada, no lo toques: pídele otro en el panel del asistente.',
        },
        {
          t: 'Envíalo tú',
          d: 'Nada se envía solo. Cuando estés conforme, pulsa enviar.',
          screen: 'reader',
          highlight: 'actions',
        },
      ],
      tips: [
        'Si quieres decirle cómo tiene que ser la respuesta antes de que la escriba, usa las respuestas sugeridas: hay una guía dedicada.',
        'Cuanto más lo uses, más se parece a ti: aprende de los correos que has enviado.',
      ],
      faq: [
        {
          q: '¿Se enviará solo sin que yo lo vea?',
          a: 'Nunca. Nukli deja el texto escrito y ya está; el botón de enviar lo pulsas tú.',
        },
        {
          q: '¿Y si dice algo que no es cierto?',
          a: 'Para eso lo lees antes. Si dudas de un dato, bórralo: la IA es buena escribiendo, no adivinando.',
        },
        {
          q: '¿Consume de mi plan?',
          a: 'Sí, cada respuesta gasta un poquito de tu cuota de IA del mes. Puedes verlo en Ajustes > Cuenta.',
        },
      ],
    },
    en: {
      title: 'Replying to an email in three clicks with AI',
      lead: 'The fastest way to answer: open it, press one button, read what it wrote for you.',
      answer:
        'Open the email and press “Reply with AI” in the bar underneath. Nukli reads the whole conversation and leaves a draft in the reply box in your tone. Read it, change whatever you want, and send it yourself.',
      steps: [
        {
          t: 'Open the email',
          d: 'One click on the row in the list, as usual. The email has to be open so the AI knows what it is about.',
          screen: 'inbox',
          highlight: 'list',
        },
        {
          t: 'Press “Reply with AI”',
          d: 'The button with the little star, in the bar under the message, next to the plain reply button.',
          screen: 'reader',
          highlight: 'actions',
        },
        {
          t: 'Wait a couple of seconds',
          d: 'Nukli reads the whole thread and looks at how you answered similar emails before, so it writes the way you write.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Read it and change what you like',
          d: 'The draft lands in the reply box. It is ordinary text: delete, add and rewrite as you please.',
          screen: 'reader',
          highlight: 'actions',
          tip: 'If you do not like it at all, leave it and ask for a different one in the assistant panel.',
        },
        {
          t: 'You send it',
          d: 'Nothing goes out on its own. When you are happy, press send.',
          screen: 'reader',
          highlight: 'actions',
        },
      ],
      tips: [
        'If you want to tell it what the reply should be like before it writes, use the suggested replies — there is a guide for that.',
        'The more you use it, the more it sounds like you: it learns from the emails you have sent.',
      ],
      faq: [
        {
          q: 'Could it send without me seeing it?',
          a: 'Never. Nukli writes the text and stops there; you press send.',
        },
        {
          q: 'What if it says something that is not true?',
          a: 'That is why you read it first. If you are unsure about a detail, delete it: the AI is good at writing, not at guessing.',
        },
        {
          q: 'Does it use up my plan?',
          a: 'Yes, each reply spends a little of your monthly AI allowance. You can see it in Settings > Account.',
        },
      ],
    },
  },

  {
    slug: 'suggested-replies',
    id: 'suggested-replies',
    category: 'ai',
    icon: 'list-checks',
    level: 'basic',
    plan: 'free',
    minutes: 3,
    topics: [
      'respostes suggerides', 'respuestas sugeridas', 'suggested replies', 'opciones de respuesta',
      'enfoque', 'a b c', 'elegir respuesta', 'triar resposta', 'qué contesto', 'no sé qué contestar',
    ],
    ca: {
      title: 'Les respostes suggerides: tria l’enfocament abans d’escriure',
      lead: 'Quan obres un correu, Nukli et proposa dues o tres maneres de contestar. Trien el camí, no el text.',
      answer:
        'Sota el correu obert apareixen unes quantes maneres de contestar (acceptar, demanar més informació, dir que no…). Prem la que t’encaixi i l’assistent escriurà la resposta seguint aquest enfocament. També pots escriure la teva pròpia instrucció a la caixeta de sota.',
      steps: [
        {
          t: 'Obre un correu que demani resposta',
          d: 'Les suggerides surten quan Nukli veu que el missatge espera alguna cosa de tu.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Mira les opcions',
          d: 'Just a sota del text hi ha una llisteta amb lletres A, B, C. Cada una és un camí diferent: acceptar, ajornar, demanar detalls…',
          screen: 'reader',
          highlight: 'suggested',
        },
        {
          t: 'Prem la que vulguis',
          d: 'No s’envia res: només li dius a l’assistent per on ha de tirar. Ell escriurà la resposta sencera amb aquest enfocament.',
          screen: 'reader',
          highlight: 'suggested',
        },
        {
          t: 'O escriu la teva',
          d: 'A sota de les opcions hi ha una caixeta per dir-ho amb les teves paraules: “digues que sí però que arribaré tard”.',
          screen: 'reader',
          highlight: 'suggested',
        },
      ],
      tips: [
        'Si cap opció t’encaixa, prem “Torna a generar” i te’n proposarà d’altres.',
        'Les opcions són suggeriments, no decisions: pots canviar d’idea un cop llegit l’esborrany.',
      ],
      faq: [
        {
          q: 'Si premo una opció, s’envia el correu?',
          a: 'No. Només li dona la instrucció a l’assistent. Després encara has de llegir l’esborrany i prémer enviar.',
        },
        {
          q: 'No em surten opcions en aquest correu',
          a: 'Vol dir que Nukli no hi ha vist cap pregunta ni cap petició. Sempre pots respondre a mà o demanar-ho al xat.',
        },
      ],
    },
    es: {
      title: 'Las respuestas sugeridas: elige el enfoque antes de escribir',
      lead: 'Al abrir un correo, Nukli te propone dos o tres maneras de contestar. Eliges el camino, no el texto.',
      answer:
        'Debajo del correo abierto aparecen varias maneras de contestar (aceptar, pedir más información, decir que no…). Pulsa la que te encaje y el asistente escribirá la respuesta con ese enfoque. También puedes escribir tu propia instrucción en la cajita de abajo.',
      steps: [
        {
          t: 'Abre un correo que pida respuesta',
          d: 'Las sugeridas salen cuando Nukli ve que el mensaje espera algo de ti.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Mira las opciones',
          d: 'Justo debajo del texto hay una lista con letras A, B, C. Cada una es un camino distinto: aceptar, aplazar, pedir detalles…',
          screen: 'reader',
          highlight: 'suggested',
        },
        {
          t: 'Pulsa la que quieras',
          d: 'No se envía nada: solo le dices al asistente por dónde tirar. Él escribirá la respuesta entera con ese enfoque.',
          screen: 'reader',
          highlight: 'suggested',
        },
        {
          t: 'O escribe la tuya',
          d: 'Debajo de las opciones hay una cajita para decirlo con tus palabras: “dile que sí pero que llegaré tarde”.',
          screen: 'reader',
          highlight: 'suggested',
        },
      ],
      tips: [
        'Si ninguna opción te encaja, pulsa “Regenerar” y te propondrá otras.',
        'Las opciones son sugerencias, no decisiones: puedes cambiar de idea una vez leído el borrador.',
      ],
      faq: [
        {
          q: 'Si pulso una opción, ¿se envía el correo?',
          a: 'No. Solo le da la instrucción al asistente. Después todavía tienes que leer el borrador y pulsar enviar.',
        },
        {
          q: 'A mí no me salen opciones en este correo',
          a: 'Significa que Nukli no ha visto ninguna pregunta ni petición. Siempre puedes responder a mano o pedirlo en el chat.',
        },
      ],
    },
    en: {
      title: 'Suggested replies: pick the angle before anything is written',
      lead: 'When you open an email, Nukli offers two or three ways of answering. You choose the road, not the words.',
      answer:
        'Under the open email you get a few ways of answering (accept, ask for more information, decline…). Press the one that fits and the assistant writes the reply along those lines. You can also type your own instruction in the little box below.',
      steps: [
        {
          t: 'Open an email that needs an answer',
          d: 'Suggestions appear when Nukli can see the message is waiting on you.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Look at the options',
          d: 'Right under the text there is a short list marked A, B, C. Each one is a different road: accept, postpone, ask for details…',
          screen: 'reader',
          highlight: 'suggested',
        },
        {
          t: 'Press the one you want',
          d: 'Nothing is sent: you are just telling the assistant which way to go. It writes the full reply along that line.',
          screen: 'reader',
          highlight: 'suggested',
        },
        {
          t: 'Or write your own',
          d: 'Below the options there is a box to say it in your own words: “tell them yes, but that I will be late”.',
          screen: 'reader',
          highlight: 'suggested',
        },
      ],
      tips: [
        'If none of them fit, press “Regenerate” and you get a different set.',
        'The options are suggestions, not decisions: you can change your mind after reading the draft.',
      ],
      faq: [
        {
          q: 'If I press an option, does the email go out?',
          a: 'No. It only gives the assistant an instruction. You still have to read the draft and press send.',
        },
        {
          q: 'I get no options on this email',
          a: 'That means Nukli saw no question or request in it. You can always reply by hand or ask in the chat.',
        },
      ],
    },
  },

  {
    slug: 'summarize-long-threads',
    id: 'summarize',
    category: 'ai',
    icon: 'text-quote',
    level: 'basic',
    plan: 'free',
    minutes: 3,
    topics: [
      'resumir', 'resum', 'summary', 'summarize', 'hilo largo', 'fil llarg', 'conversación larga',
      'no me entero', 'demasiado largo', 'massa llarg', 'qué me piden', 'resumen del día',
    ],
    ca: {
      title: 'Resumir una conversa llarga (i el correu del dia)',
      lead: 'Quan un fil té quinze missatges i tots responen a tots, demana-li que t’ho expliqui en quatre línies.',
      answer:
        'Obre el correu i escriu a l’assistent “resumeix-me aquesta conversa”. Per al conjunt del dia, no obris cap correu i demana-li “resumeix-me els correus d’avui” o “què he rebut aquesta setmana”.',
      steps: [
        {
          t: 'Per a un fil concret: obre’l',
          d: 'Fes clic al correu de la llista. L’assistent llegeix tota la conversa, no només l’últim missatge.',
          screen: 'inbox',
          highlight: 'list',
        },
        {
          t: 'Demana-li el resum',
          d: '“Resumeix-me això”, “què m’estan demanant?”, “fes-me’n un resum de cinc punts”. Contesta al panell de la dreta.',
          screen: 'chat',
          highlight: 'input',
        },
        {
          t: 'Per al dia sencer: no obris res',
          d: 'Tanca el correu obert i demana-li “resumeix-me els correus d’avui”. Ell mateix mirarà el que ha arribat.',
          screen: 'chat',
          highlight: 'input',
        },
        {
          t: 'Estira del fil',
          d: 'Al mateix xat pots continuar: “d’aquests, quins són urgents?”, “obre’m el de la Marta”. Si li demanes que n’obri un, l’obre.',
          screen: 'chat',
          highlight: 'thread',
        },
      ],
      tips: [
        'Frases útils: “resumeix-me els últims 10 correus”, “què he rebut aquesta setmana”, “fes-me una llista del que he de contestar”.',
        'Si la conversa és en un altre idioma, el resum te’l fa igualment en el teu.',
      ],
      faq: [
        {
          q: 'Es queda el resum guardat?',
          a: 'Queda a la conversa del xat, que es manté mentre no la tanquis. El correu no es toca.',
        },
      ],
    },
    es: {
      title: 'Resumir una conversación larga (y el correo del día)',
      lead: 'Cuando un hilo tiene quince mensajes y todos responden a todos, pídele que te lo cuente en cuatro líneas.',
      answer:
        'Abre el correo y escribe al asistente “resúmeme esta conversación”. Para el conjunto del día, no abras ningún correo y pídele “resúmeme los correos de hoy” o “qué he recibido esta semana”.',
      steps: [
        {
          t: 'Para un hilo concreto: ábrelo',
          d: 'Haz clic en el correo de la lista. El asistente lee toda la conversación, no solo el último mensaje.',
          screen: 'inbox',
          highlight: 'list',
        },
        {
          t: 'Pídele el resumen',
          d: '“Resúmeme esto”, “¿qué me están pidiendo?”, “hazme un resumen de cinco puntos”. Contesta en el panel de la derecha.',
          screen: 'chat',
          highlight: 'input',
        },
        {
          t: 'Para el día entero: no abras nada',
          d: 'Cierra el correo abierto y pídele “resúmeme los correos de hoy”. Él mismo mirará lo que ha llegado.',
          screen: 'chat',
          highlight: 'input',
        },
        {
          t: 'Tira del hilo',
          d: 'En el mismo chat puedes seguir: “de estos, ¿cuáles son urgentes?”, “ábreme el de Marta”. Si le pides que abra uno, lo abre.',
          screen: 'chat',
          highlight: 'thread',
        },
      ],
      tips: [
        'Frases útiles: “resúmeme los últimos 10 correos”, “qué he recibido esta semana”, “hazme una lista de lo que tengo que contestar”.',
        'Si la conversación está en otro idioma, el resumen te lo hace igualmente en el tuyo.',
      ],
      faq: [
        {
          q: '¿El resumen se queda guardado?',
          a: 'Queda en la conversación del chat, que se mantiene mientras no la cierres. El correo no se toca.',
        },
      ],
    },
    en: {
      title: 'Summarising a long thread (and the day’s mail)',
      lead: 'When a thread has fifteen messages and everyone replies to everyone, ask for it in four lines.',
      answer:
        'Open the email and tell the assistant “summarise this conversation”. For the whole day, close any open email and ask “summarise today’s emails” or “what did I get this week”.',
      steps: [
        {
          t: 'For one thread: open it',
          d: 'Click the email in the list. The assistant reads the entire conversation, not just the last message.',
          screen: 'inbox',
          highlight: 'list',
        },
        {
          t: 'Ask for the summary',
          d: '“Summarise this”, “what are they asking me for?”, “give me five bullet points”. It answers in the right-hand panel.',
          screen: 'chat',
          highlight: 'input',
        },
        {
          t: 'For the whole day: open nothing',
          d: 'Close the open email and ask “summarise today’s emails”. It will go and look at what arrived.',
          screen: 'chat',
          highlight: 'input',
        },
        {
          t: 'Keep pulling',
          d: 'In the same chat you can carry on: “which of those are urgent?”, “open Marta’s one”. If you ask it to open one, it opens it.',
          screen: 'chat',
          highlight: 'thread',
        },
      ],
      tips: [
        'Handy phrases: “summarise my last 10 emails”, “what did I get this week”, “list what I still have to answer”.',
        'If the conversation is in another language, you still get the summary in yours.',
      ],
      faq: [
        {
          q: 'Is the summary saved?',
          a: 'It stays in the chat conversation for as long as you keep it open. The email itself is untouched.',
        },
      ],
    },
  },

  {
    slug: 'set-up-your-assistant',
    id: 'assistant-setup',
    category: 'ai',
    icon: 'user-cog',
    level: 'medium',
    plan: 'free',
    minutes: 5,
    topics: [
      'assistent', 'asistente', 'assistant', 'tono', 'to', 'tone', 'firma', 'signatura', 'signature',
      'personalizar', 'personalitzar', 'escribe raro', 'no escribe como yo', 'instrucciones',
      'condiciones de la empresa', 'condicions', 'company policies', 'varios asistentes',
    ],
    ca: {
      title: 'Ensenyar-li qui ets: to, signatura i condicions',
      lead: 'Cinc minuts de configuració i les respostes deixaran de sonar a robot.',
      answer:
        'Vés a Configuració > Assistents. Allà hi escrius en nom de qui parles, quin to vols i com signes. També pots enganxar-hi les condicions de la teva empresa perquè les consulti quan calgui. Si portes més d’una adreça, fes un assistent per a cadascuna.',
      steps: [
        {
          t: 'Obre Configuració > Assistents',
          d: 'L’engranatge de baix de la barra d’icones i, a dalt, la pestanya “Assistents”. Ja n’hi ha un de creat des del principi.',
          screen: 'settings-assistants',
          highlight: 'tabs',
        },
        {
          t: 'Escriu les instruccions',
          d: 'En paraules normals: “Parles en nom de la Marta, de l’Estudi Serra. To amable però professional. Tracta de vostè els clients nous.” Res de tecnicismes.',
          screen: 'settings-assistant-edit',
          highlight: 'instructions',
        },
        {
          t: 'Posa-hi la signatura',
          d: 'Dins de les mateixes instruccions, tal com vols que acabin els correus: “Salutacions cordials, Marta — Estudi Serra”. La posarà sempre.',
          screen: 'settings-assistant-edit',
          highlight: 'instructions',
        },
        {
          t: 'Afegeix les condicions (si en tens)',
          d: 'Devolucions, terminis, garanties, preus. L’assistent només les llegeix quan un correu ho demana, i així no s’inventa res.',
          screen: 'settings-assistant-edit',
          highlight: 'conditions',
        },
        {
          t: 'Deixa que aprengui del teu estil',
          d: 'Assigna-li els comptes de correu i prem “Genera a partir dels enviats”: mirarà els correus que has enviat i n’extraurà la teva manera d’escriure.',
          screen: 'settings-assistant-edit',
          highlight: 'style',
        },
      ],
      tips: [
        'Si portes la feina i el correu personal, fes dos assistents i assigna a cadascun el seu compte: així no es barregen mai.',
        'La primera vegada, l’assistent et pot fer quatre preguntes i configurar-se sol a partir dels teus correus enviats.',
      ],
      faq: [
        {
          q: 'Puc canviar-ho més endavant?',
          a: 'Sempre. És text normal: entres, l’edites i la propera resposta ja surt diferent.',
        },
        {
          q: 'Què són les “condicions de l’empresa”?',
          a: 'Les teves normes escrites (devolucions, terminis, garanties). Serveixen perquè, davant d’una reclamació, contesti amb la teva política de veritat i no amb una de plausible.',
        },
      ],
    },
    es: {
      title: 'Enseñarle quién eres: tono, firma y condiciones',
      lead: 'Cinco minutos de configuración y las respuestas dejarán de sonar a robot.',
      answer:
        'Ve a Ajustes > Asistentes. Ahí escribes en nombre de quién habla, qué tono quieres y cómo firmas. También puedes pegar las condiciones de tu empresa para que las consulte cuando haga falta. Si llevas más de una dirección, haz un asistente para cada una.',
      steps: [
        {
          t: 'Abre Ajustes > Asistentes',
          d: 'El engranaje del fondo de la barra de iconos y, arriba, la pestaña “Asistentes”. Ya hay uno creado desde el principio.',
          screen: 'settings-assistants',
          highlight: 'tabs',
        },
        {
          t: 'Escribe las instrucciones',
          d: 'En palabras normales: “Hablas en nombre de Marta, de Estudio Serra. Tono amable pero profesional. Trata de usted a los clientes nuevos.” Nada de tecnicismos.',
          screen: 'settings-assistant-edit',
          highlight: 'instructions',
        },
        {
          t: 'Pon la firma',
          d: 'Dentro de las mismas instrucciones, tal cual quieres que terminen los correos: “Un cordial saludo, Marta — Estudio Serra”. La pondrá siempre.',
          screen: 'settings-assistant-edit',
          highlight: 'instructions',
        },
        {
          t: 'Añade las condiciones (si tienes)',
          d: 'Devoluciones, plazos, garantías, precios. El asistente solo las lee cuando un correo lo pide, y así no se inventa nada.',
          screen: 'settings-assistant-edit',
          highlight: 'conditions',
        },
        {
          t: 'Deja que aprenda tu estilo',
          d: 'Asígnale las cuentas de correo y pulsa “Generar a partir de los enviados”: mirará los correos que has mandado y sacará tu manera de escribir.',
          screen: 'settings-assistant-edit',
          highlight: 'style',
        },
      ],
      tips: [
        'Si llevas el trabajo y el correo personal, haz dos asistentes y asigna a cada uno su cuenta: así no se mezclan nunca.',
        'La primera vez, el asistente puede hacerte cuatro preguntas y configurarse solo a partir de tus correos enviados.',
      ],
      faq: [
        {
          q: '¿Puedo cambiarlo más adelante?',
          a: 'Siempre. Es texto normal: entras, lo editas y la siguiente respuesta ya sale distinta.',
        },
        {
          q: '¿Qué son las “condiciones de la empresa”?',
          a: 'Tus normas escritas (devoluciones, plazos, garantías). Sirven para que, ante una reclamación, conteste con tu política de verdad y no con una plausible.',
        },
      ],
    },
    en: {
      title: 'Teaching it who you are: tone, signature and policies',
      lead: 'Five minutes of setup and the replies stop sounding like a robot.',
      answer:
        'Go to Settings > Assistants. There you write who it speaks for, what tone you want and how you sign off. You can also paste your company policies so it can check them when needed. If you run more than one address, make one assistant per address.',
      steps: [
        {
          t: 'Open Settings > Assistants',
          d: 'The cog at the bottom of the icon bar, then the “Assistants” tab along the top. There is already one there from the start.',
          screen: 'settings-assistants',
          highlight: 'tabs',
        },
        {
          t: 'Write the instructions',
          d: 'In plain words: “You speak for Marta, of Serra Studio. Warm but professional. Be formal with new clients.” No jargon needed.',
          screen: 'settings-assistant-edit',
          highlight: 'instructions',
        },
        {
          t: 'Add your sign-off',
          d: 'Inside those same instructions, exactly how you want emails to end: “Kind regards, Marta — Serra Studio”. It will use it every time.',
          screen: 'settings-assistant-edit',
          highlight: 'instructions',
        },
        {
          t: 'Add your policies (if you have any)',
          d: 'Returns, deadlines, warranties, prices. The assistant only reads them when an email calls for it, so it never has to invent anything.',
          screen: 'settings-assistant-edit',
          highlight: 'conditions',
        },
        {
          t: 'Let it learn your style',
          d: 'Assign your mail accounts to it and press “Generate from sent emails”: it reads what you have sent and extracts the way you write.',
          screen: 'settings-assistant-edit',
          highlight: 'style',
        },
      ],
      tips: [
        'If you run work and personal mail, make two assistants and give each its own account so they never mix.',
        'The first time, the assistant may ask you four questions and set itself up from your sent mail.',
      ],
      faq: [
        {
          q: 'Can I change it later?',
          a: 'Any time. It is ordinary text: edit it and the next reply comes out differently.',
        },
        {
          q: 'What are “company policies”?',
          a: 'Your written rules (returns, deadlines, warranties). They mean that when a complaint arrives it answers with your real policy instead of a plausible-sounding one.',
        },
      ],
    },
  },

  {
    slug: 'quick-edit-text',
    id: 'quick-edit',
    category: 'ai',
    icon: 'text-cursor',
    level: 'basic',
    plan: 'free',
    minutes: 3,
    topics: [
      'edició ràpida', 'edicion rapida', 'quick edit', 'cambiar un trozo', 'reescribir', 'reescriure',
      'más corto', 'més curt', 'más amable', 'rewrite', 'shorten', 'seleccionar texto', 'mejorar frase',
    ],
    ca: {
      title: 'Canviar només un tros del text',
      lead: 'No cal refer tot el correu perquè una frase no acabi de sonar bé.',
      answer:
        'Selecciona amb el ratolí el tros que no t’agrada. Sortirà un botonet: prem “Edició ràpida”, escriu què vols (“més curt”, “més amable”, “en anglès”) i el canvi es fa només en aquell tros.',
      steps: [
        {
          t: 'Selecciona el text',
          d: 'Arrossega el ratolí per sobre de la frase o el paràgraf que vulguis canviar, dins de la caixa de resposta.',
          screen: 'reply',
          highlight: 'box',
        },
        {
          t: 'Prem “Edició ràpida”',
          d: 'Apareix una barreta flotant amb dues opcions: afegir-ho al xat o edició ràpida.',
          screen: 'reply',
          highlight: 'box',
        },
        {
          t: 'Digues què vols',
          d: '“Més curt”, “menys sec”, “tracta’l de vostè”, “tradueix-ho a l’anglès”, “treu la part del preu”. Una frase i prou.',
        },
        {
          t: 'Accepta o rebutja',
          d: 'Veuràs el canvi marcat. Si t’agrada, l’acceptes; si no, el rebutges i queda com estava.',
          screen: 'reply',
          highlight: 'box',
        },
      ],
      tips: [
        'L’altra opció de la barreta, “Afegeix al xat”, envia aquest tros a l’assistent per parlar-ne sense tocar-lo.',
        'Funciona igual amb un text que t’han enviat: selecciona’l i demana que te l’expliqui.',
      ],
      faq: [
        {
          q: 'Em canviarà la resta del correu?',
          a: 'No. L’edició ràpida només toca el que hagis seleccionat.',
        },
      ],
    },
    es: {
      title: 'Cambiar solo un trozo del texto',
      lead: 'No hace falta rehacer todo el correo porque una frase no acabe de sonar bien.',
      answer:
        'Selecciona con el ratón el trozo que no te gusta. Saldrá un botoncito: pulsa “Edición rápida”, escribe qué quieres (“más corto”, “más amable”, “en inglés”) y el cambio se hace solo en ese trozo.',
      steps: [
        {
          t: 'Selecciona el texto',
          d: 'Arrastra el ratón por encima de la frase o el párrafo que quieras cambiar, dentro de la caja de respuesta.',
          screen: 'reply',
          highlight: 'box',
        },
        {
          t: 'Pulsa “Edición rápida”',
          d: 'Aparece una barrita flotante con dos opciones: añadirlo al chat o edición rápida.',
          screen: 'reply',
          highlight: 'box',
        },
        {
          t: 'Di qué quieres',
          d: '“Más corto”, “menos seco”, “trátalo de usted”, “tradúcelo al inglés”, “quita la parte del precio”. Una frase basta.',
        },
        {
          t: 'Acepta o rechaza',
          d: 'Verás el cambio marcado. Si te gusta, lo aceptas; si no, lo rechazas y queda como estaba.',
          screen: 'reply',
          highlight: 'box',
        },
      ],
      tips: [
        'La otra opción de la barrita, “Añadir al chat”, manda ese trozo al asistente para hablar de él sin tocarlo.',
        'Funciona igual con un texto que te han enviado: selecciónalo y pide que te lo explique.',
      ],
      faq: [
        {
          q: '¿Me cambiará el resto del correo?',
          a: 'No. La edición rápida solo toca lo que hayas seleccionado.',
        },
      ],
    },
    en: {
      title: 'Changing just one piece of the text',
      lead: 'You do not have to redo the whole email because one sentence does not sit right.',
      answer:
        'Select the bit you do not like with the mouse. A small button appears: press “Quick edit”, say what you want (“shorter”, “friendlier”, “in Spanish”) and only that piece changes.',
      steps: [
        {
          t: 'Select the text',
          d: 'Drag the mouse over the sentence or paragraph you want to change, inside the reply box.',
          screen: 'reply',
          highlight: 'box',
        },
        {
          t: 'Press “Quick edit”',
          d: 'A small floating bar appears with two options: add it to the chat, or quick edit.',
          screen: 'reply',
          highlight: 'box',
        },
        {
          t: 'Say what you want',
          d: '“Shorter”, “less blunt”, “more formal”, “translate it into Spanish”, “drop the part about the price”. One sentence is enough.',
        },
        {
          t: 'Accept or reject',
          d: 'You see the change marked up. Accept it if you like it; reject it and everything stays as it was.',
          screen: 'reply',
          highlight: 'box',
        },
      ],
      tips: [
        'The other option in that bar, “Add to chat”, sends the passage to the assistant so you can discuss it without changing it.',
        'It works the same on text somebody sent you: select it and ask for an explanation.',
      ],
      faq: [
        {
          q: 'Will it change the rest of the email?',
          a: 'No. Quick edit only touches what you selected.',
        },
      ],
    },
  },

  {
    slug: 'quick-actions',
    id: 'quick-actions',
    category: 'ai',
    icon: 'wand-sparkles',
    level: 'medium',
    plan: 'free',
    minutes: 4,
    topics: [
      'accions ràpides', 'acciones rápidas', 'quick actions', 'botones a medida', 'atajo ia',
      'macro', 'repetir la misma orden', 'siempre le pido lo mismo', 'personalizar botones',
    ],
    ca: {
      title: 'Accions ràpides: els teus propis botons',
      lead: 'Si cada dia li demanes el mateix a l’assistent, converteix-ho en un botó i estalvia’t d’escriure-ho.',
      answer:
        'A la barra d’accions ràpides pots crear els teus propis botons amb l’ordre que repeteixes sempre (“resumeix-me això en tres punts”, “tradueix a l’anglès”). Un cop creat, un clic fa la feina sobre el correu obert.',
      steps: [
        {
          t: 'Obre les accions ràpides',
          d: 'És el botó amb el llamp, a la zona del correu obert. Hi surten les accions que ja tens.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Entra a la configuració i prem “Nova”',
          d: 'Al mateix desplegable hi ha l’engranatge de configuració.',
        },
        {
          t: 'Posa-li nom i icona',
          d: 'Un nom curt que reconeguis d’un cop d’ull: “Resumeix”, “A l’anglès”, “Més formal”.',
        },
        {
          t: 'Escriu l’ordre',
          d: 'El que li diries al xat: “Resumeix aquest correu en tres punts i digues què he de contestar”. Pots fer servir variables com l’assumpte o el remitent.',
        },
        {
          t: 'Prova-la',
          d: 'Obre un correu qualsevol i prem el botó nou. Si l’ordre no acaba de fer el que vols, torna-hi i afina-la.',
          screen: 'reader',
          highlight: 'body',
        },
      ],
      tips: [
        'Idees d’accions: “Explica-m’ho fàcil”, “Treu-ne les dates”, “Fes-ne una llista de tasques”, “Contesta amb educació que no”.',
        'A la casella del text pots inserir l’assumpte o el remitent del correu perquè l’ordre en parli.',
      ],
      faq: [
        {
          q: 'Puc esborrar-ne una?',
          a: 'Sí, des de la mateixa configuració d’accions ràpides.',
        },
      ],
    },
    es: {
      title: 'Acciones rápidas: tus propios botones',
      lead: 'Si cada día le pides lo mismo al asistente, conviértelo en un botón y ahórrate escribirlo.',
      answer:
        'En la barra de acciones rápidas puedes crear tus propios botones con la orden que repites siempre (“resúmeme esto en tres puntos”, “traduce al inglés”). Una vez creado, un clic hace el trabajo sobre el correo abierto.',
      steps: [
        {
          t: 'Abre las acciones rápidas',
          d: 'Es el botón con el rayo, en la zona del correo abierto. Ahí salen las acciones que ya tengas.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Entra en los ajustes y pulsa “Nueva”',
          d: 'En el mismo desplegable está el engranaje de configuración.',
        },
        {
          t: 'Ponle nombre e icono',
          d: 'Un nombre corto que reconozcas de un vistazo: “Resume”, “Al inglés”, “Más formal”.',
        },
        {
          t: 'Escribe la orden',
          d: 'Lo que le dirías en el chat: “Resume este correo en tres puntos y dime qué tengo que contestar”. Puedes usar variables como el asunto o el remitente.',
        },
        {
          t: 'Pruébala',
          d: 'Abre un correo cualquiera y pulsa el botón nuevo. Si la orden no acaba de hacer lo que quieres, vuelve y afínala.',
          screen: 'reader',
          highlight: 'body',
        },
      ],
      tips: [
        'Ideas de acciones: “Explícamelo fácil”, “Sácame las fechas”, “Hazme una lista de tareas”, “Contesta con educación que no”.',
        'En la casilla del texto puedes insertar el asunto o el remitente del correo para que la orden hable de ellos.',
      ],
      faq: [
        {
          q: '¿Puedo borrar alguna?',
          a: 'Sí, desde la misma configuración de acciones rápidas.',
        },
      ],
    },
    en: {
      title: 'Quick actions: buttons of your own',
      lead: 'If you ask the assistant the same thing every day, turn it into a button and stop typing it.',
      answer:
        'In the quick actions bar you can create your own buttons holding the instruction you always repeat (“summarise this in three points”, “translate to English”). Once created, one click does the job on the open email.',
      steps: [
        {
          t: 'Open quick actions',
          d: 'The lightning-bolt button in the open-email area. Any actions you already have show up there.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Go into the settings and press “New”',
          d: 'The cog for settings is in the same dropdown.',
        },
        {
          t: 'Give it a name and an icon',
          d: 'Something short you recognise instantly: “Summarise”, “To English”, “More formal”.',
        },
        {
          t: 'Write the instruction',
          d: 'What you would say in the chat: “Summarise this email in three points and tell me what to answer”. You can insert variables such as the subject or the sender.',
        },
        {
          t: 'Try it',
          d: 'Open any email and press the new button. If the instruction does not quite do what you want, go back and refine it.',
          screen: 'reader',
          highlight: 'body',
        },
      ],
      tips: [
        'Ideas: “Explain it simply”, “Pull out the dates”, “Turn it into a to-do list”, “Politely decline”.',
        'In the instruction box you can insert the email’s subject or sender so the instruction refers to them.',
      ],
      faq: [
        {
          q: 'Can I delete one?',
          a: 'Yes, from the same quick-actions settings.',
        },
      ],
    },
  },

  {
    slug: 'write-a-new-email-with-ai',
    id: 'compose-with-ai',
    category: 'ai',
    icon: 'pencil-line',
    level: 'basic',
    plan: 'free',
    minutes: 4,
    topics: [
      'escriure correu nou', 'escribir correo nuevo', 'new email', 'compose', 'redactar',
      'no sé cómo empezar', 'carta', 'reclamación', 'reclamació', 'pedir cita', 'demanar hora',
      'escribir desde cero',
    ],
    ca: {
      title: 'Escriure un correu nou amb ajuda',
      lead: 'Per als correus que costen: la reclamació, la carta a l’administrador, el missatge que fa dies que vas ajornant.',
      answer:
        'Demana-li-ho directament a l’assistent: “escriu un correu a X demanant Y”. Et prepararà el correu nou amb assumpte i tot. També pots prémer el botó de correu nou i demanar-li que ompli el text.',
      steps: [
        {
          t: 'Digues-ho al xat de l’assistent',
          d: 'Amb una frase: “Escriu un correu a la companyia de la llum reclamant una factura que em sembla equivocada”. Dona-li els detalls que sàpigues.',
          screen: 'chat',
          highlight: 'input',
        },
        {
          t: 'Deixa que obri el correu nou',
          d: 'Nukli obrirà una finestra de correu nou amb el text ja posat, assumpte inclòs.',
          screen: 'inbox',
          highlight: 'compose',
        },
        {
          t: 'Posa el destinatari',
          d: 'Escriu l’adreça al camp “Per a”. Si l’has esmentat pel nom i la tens als teus correus, sovint ja te la posa.',
        },
        {
          t: 'Ajusta el que calgui',
          d: 'Al xat li pots dir “més sec”, “afegeix el número de contracte”, “més curt”. També pots escriure-hi tu directament.',
        },
        {
          t: 'Envia’l tu',
          d: 'Llegeix-lo un últim cop i prem enviar. Si el vols per a més tard, mira la guia d’enviament programat.',
        },
      ],
      tips: [
        'Digues-li per a qui és i què vols aconseguir; la resta ja te la redacta.',
        'Si has de fer el mateix correu cada mes, desa’l com a plantilla: “desa això com a plantilla”.',
      ],
      faq: [
        {
          q: 'Puc adjuntar-hi un fitxer?',
          a: 'Sí. Pots arrossegar-hi el fitxer o demanar-li a l’assistent que adjunti un document que t’han enviat abans.',
        },
      ],
    },
    es: {
      title: 'Escribir un correo nuevo con ayuda',
      lead: 'Para los correos que cuestan: la reclamación, la carta al administrador, el mensaje que llevas días aplazando.',
      answer:
        'Pídeselo directamente al asistente: “escribe un correo a X pidiendo Y”. Te preparará el correo nuevo con asunto y todo. También puedes pulsar el botón de correo nuevo y pedirle que rellene el texto.',
      steps: [
        {
          t: 'Díselo en el chat del asistente',
          d: 'Con una frase: “Escribe un correo a la compañía de la luz reclamando una factura que me parece equivocada”. Dale los datos que sepas.',
          screen: 'chat',
          highlight: 'input',
        },
        {
          t: 'Deja que abra el correo nuevo',
          d: 'Nukli abrirá una ventana de correo nuevo con el texto ya puesto, asunto incluido.',
          screen: 'inbox',
          highlight: 'compose',
        },
        {
          t: 'Pon el destinatario',
          d: 'Escribe la dirección en el campo “Para”. Si lo has mencionado por su nombre y lo tienes en tus correos, muchas veces ya te la pone.',
        },
        {
          t: 'Ajusta lo que haga falta',
          d: 'En el chat puedes decirle “más seco”, “añade el número de contrato”, “más corto”. También puedes escribir tú directamente.',
        },
        {
          t: 'Envíalo tú',
          d: 'Léelo una última vez y pulsa enviar. Si lo quieres para más tarde, mira la guía de envío programado.',
        },
      ],
      tips: [
        'Dile para quién es y qué quieres conseguir; el resto ya te lo redacta.',
        'Si tienes que hacer el mismo correo cada mes, guárdalo como plantilla: “guarda esto como plantilla”.',
      ],
      faq: [
        {
          q: '¿Puedo adjuntar un archivo?',
          a: 'Sí. Puedes arrastrar el archivo o pedirle al asistente que adjunte un documento que te enviaron antes.',
        },
      ],
    },
    en: {
      title: 'Writing a new email with help',
      lead: 'For the emails that are hard work: the complaint, the letter to the building manager, the message you keep putting off.',
      answer:
        'Just ask the assistant: “write an email to X asking for Y”. It prepares the new email, subject and all. You can also press the new-email button and ask it to fill in the text.',
      steps: [
        {
          t: 'Say it in the assistant chat',
          d: 'One sentence: “Write to the electricity company disputing a bill that looks wrong”. Give it whatever details you know.',
          screen: 'chat',
          highlight: 'input',
        },
        {
          t: 'Let it open the new email',
          d: 'Nukli opens a compose window with the text already in place, subject included.',
          screen: 'inbox',
          highlight: 'compose',
        },
        {
          t: 'Add the recipient',
          d: 'Type the address in the “To” field. If you named the person and they are in your mail, it often fills it in for you.',
        },
        {
          t: 'Adjust anything you need',
          d: 'In the chat you can say “more direct”, “add the contract number”, “shorter”. Or just type in the message yourself.',
        },
        {
          t: 'You send it',
          d: 'Read it one last time and press send. If you want it to go later, see the scheduled send guide.',
        },
      ],
      tips: [
        'Tell it who it is for and what you want to achieve; it handles the wording.',
        'If you send the same email every month, save it as a template: “save this as a template”.',
      ],
      faq: [
        {
          q: 'Can I attach a file?',
          a: 'Yes. Drag the file in, or ask the assistant to attach a document somebody sent you earlier.',
        },
      ],
    },
  },
];
